import {header2Search} from '@amblique/king-living/app/theme/foundations/header-2-search';

export default {
  baseStyle: {
    container: {
      position: 'relative',
    },
    inputContainer: {
      alignItems: 'center',
      gap: {base: 4, md: 8},
      minH: 9,
      pb: 4,
      width: '100%',
    },
    iconWrapper: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      height: {base: 6, md: 9},
      justifyContent: 'center',
      width: {base: 6, md: 9},
      sx: {
        ' svg': {
          height: '100%',
          width: '100%',
        },
      },
    },
    input: {
      background: 'transparent',
      border: 'none',
      borderRadius: '0',
      color: {base: 'grayAlpha.90', md: 'brandColors.primaryText'},
      flex: '1 1 0',
      fontSize: {base: '18px', md: '28px'},
      fontWeight: 400,
      height: 9,
      letterSpacing: {base: 0, md: '-0.32px'},
      lineHeight: {base: '1.5', md: '1.4'},
      minW: 0,
      px: 0,
      py: 1,
      _focus: {
        borderColor: 'transparent',
        boxShadow: 'none',
      },
      _hover: {
        borderColor: 'transparent',
      },
      _placeholder: {
        color: 'rgba(0, 0, 0, 0.3)',
        fontSize: {base: 'lg', md: '32px'},
        fontWeight: 'normal',
        letterSpacing: {base: 0, md: '-0.32px'},
        lineHeight: {base: '1.6', md: '1.2'},
      },
      sx: {
        '&::-webkit-search-cancel-button': {
          WebkitAppearance: 'none',
          display: 'none',
        },
        '&::-webkit-search-decoration': {
          WebkitAppearance: 'none',
        },
      },
    },
    clearButton: {
      flexShrink: 0,
      fontSize: {base: '2xs', md: 'xs'},
      fontWeight: 'semibold',
      height: 'auto',
      letterSpacing: {base: '2px', md: '2.4px'},
      lineHeight: '1.2',
      minW: 'auto',
      px: 0,
      size: 'sm',
      textTransform: 'uppercase',
      variant: 'ghost',
      color: 'brandColors.primaryDarkLinen',
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
      _hover: {
        bg: 'transparent',
        textDecoration: 'underline',
      },
    },
    actionsContainer: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      gap: {base: 4, md: 8},
    },
    divider: {
      borderTop: '1px solid black',
      mt: 0,
    },
    submitButton: {
      alignItems: 'center',
      color: 'brandColors.primaryText',
      display: 'flex',
      flexShrink: 0,
      h: {base: 6, md: '34px'},
      justifyContent: 'center',
      minW: {base: 6, md: '34px'},
      p: 0,
      variant: 'ghost',
      w: {base: 6, md: '34px'},
      _hover: {
        bg: 'transparent',
        opacity: 0.7,
      },
      sx: {
        ' svg': {
          height: '100%',
          width: '100%',
        },
      },
    },
    submitButtonIcon: {
      boxSize: {base: 6, md: '34px'},
    },
    floatLabel: {
      display: 'none',
    },
    bar: {
      display: 'contents',
    },
  },
  variants: {
    drawer: {
      bar: {
        display: {base: 'contents', lg: 'flex'},
        flexDirection: 'column',
        h: {lg: '56px'},
        justifyContent: 'space-between',
        pt: {lg: '8px'},
        w: 'full',
      },
      inputContainer: {
        bg: {base: 'whiteAlpha.300', lg: 'transparent'},
        borderColor: {base: 'brandColors.primaryText90', lg: 'transparent'},
        borderRadius: {base: '4px', lg: 0},
        borderStyle: 'solid',
        borderWidth: {base: '2px', lg: 0},
        boxSizing: 'border-box',
        flexShrink: 0,
        gap: {base: 3, lg: 8},
        h: {base: '44px', lg: '36px'},
        maxH: {base: '44px', lg: '36px'},
        minH: {base: '44px', lg: '36px'},
        overflow: 'hidden',
        pb: 0,
        px: {base: 4, lg: 0},
        py: {base: '2px', lg: 0},
        w: 'full',
      },
      iconWrapper: {
        height: {base: 4, lg: 8},
        width: {base: 4, lg: 8},
      },
      input: {
        ...header2Search.type.searchField,
        height: {base: 'auto', lg: '36px'},
        py: {base: 0, lg: 1},
        _placeholder: {
          ...header2Search.type.searchField,
          opacity: {base: 0.5, lg: 0.5},
        },
      },
      floatLabel: {
        ...header2Search.type.floatLabel,
        display: {base: 'block', lg: 'none'},
      },
      divider: {
        borderColor: 'brandColors.primaryText',
        borderTopWidth: '2px',
        display: {base: 'none', lg: 'block'},
        mt: 0,
        opacity: 1,
      },
      clearButton: {
        alignItems: 'center',
        color: 'brandColors.greyscale70',
        display: 'inline-flex',
        fontFamily: 'body',
        fontSize: '12px',
        fontWeight: 600,
        h: 'auto',
        height: 'auto',
        letterSpacing: '2.4px',
        lineHeight: '120%',
        minH: 0,
        p: 0,
        px: 0,
        py: 0,
        textTransform: 'uppercase',
        textDecoration: 'none',
        textUnderlineOffset: '3px',
        _hover: {
          bg: 'transparent',
          color: 'brandColors.greyscale70',
          textDecoration: 'underline',
        },
      },
      submitButton: {
        color: 'brandColors.primaryText',
        h: {base: 4, lg: 8},
        minW: {base: 4, lg: 8},
        p: 0,
        w: {base: 4, lg: 8},
      },
      submitButtonIcon: {
        boxSize: {base: 4, lg: 8},
        color: 'brandColors.primaryText',
        flexShrink: 0,
        h: {base: 4, lg: 8},
        w: {base: 4, lg: 8},
      },
      actionsContainer: {
        alignItems: 'center',
        gap: {base: 4, lg: 8},
        h: {lg: 8},
      },
    },
  },
  parts: [
    'container',
    'bar',
    'inputContainer',
    'iconWrapper',
    'input',
    'actionsContainer',
    'clearButton',
    'divider',
    'submitButton',
    'submitButtonIcon',
    'floatLabel',
  ],
};
